<ng-container>
  <app-quick-action>
  </app-quick-action>
  <app-user-profile>
  </app-user-profile>
</ng-container>